import React from 'react';
import { ChevronLeft, Share2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = ({ lot }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Navegar a la pantalla principal y activar la tab de inventario
    navigate('/', { state: { activeScreen: 'inventory' } });
  };

  return (
    <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700">
      <div className="flex items-center p-4">
        <button 
          className="mr-4 text-gray-900 dark:text-gray-100"
          onClick={handleBack}
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <div className="flex-1">
          <h1 className="text-xl font-bold text-gray-900 dark:text-white">{lot.title}</h1>
          <div className="text-sm text-gray-500 dark:text-gray-400">#{lot.display_id || lot.number}</div>
        </div>
        <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full text-gray-900 dark:text-gray-100">
          <Share2 className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Header; 